let baseUrl = '/broker';
let apiUrl = '/api';
let bpsUrl = '/broker-common-biz-service';
let msgUrl = '/broker-message-manage';
let userUrl = '/broker-auth-service';
let protoUrl = '/broker-protocol-service';
let clientUrl = '/broker-customer-client';
let productUrl = "/broker-product-service";
let orderUrl = '/broker-order-manage';
let contractUrl = '/broker-contract-service';
let financeUrl = '/broker-finance-service';
let paymentUrl = '/broker-payment-service';
let statisticsUrl = '/statistics';
const parentUrl = '/broker-partner-service';
let hwcloud = "/broker-hwcloud-manage"
let invoiceUrl = '/broker-invoice-service';   //发票相关的功能都在这个服务
let cooperativeService = "/broker-cooperative-console-service";
let TIME_COUNT = 120;
let certUrl = '/broker-cert-service'; //公共域实名认证
const PORTAL_SERVICE_NAME = '/broker-portal-service'

export {
  // 基础配置如下
  baseUrl,
  apiUrl,
  msgUrl,
  userUrl,
  protoUrl,
  clientUrl,
  productUrl,
  orderUrl,
  contractUrl,
  financeUrl,
  paymentUrl,
  statisticsUrl,
  parentUrl,
  hwcloud,
  invoiceUrl,
  cooperativeService,
  TIME_COUNT,
  certUrl,
  bpsUrl,
  PORTAL_SERVICE_NAME
}



// WEBPACK FOOTER //
// ./src/common/url-conf.js